<template>
  <Newpage/>
</template>

<script>
import Newpage from "@/components/EchartsAnalysis/scatterEcharts/index2.vue"
export default {
    components: {
        Newpage
    }
}
</script>

<style>

</style>